export const shellsShowLogo = require("./tmb_shells-logo.png");
